/**
 * Initializes and sets up the Zoho SalesIQ Live Chat widget.
 * Injects the Zoho chat script and enables drag functionality for the widget.
 * Should be called only after the user has successfully logged in.
 *
 * @param {Object} user - The logged-in user object. Should contain 'username' and 'email' properties.
 */
export function setupZohoChat(user) {
  if (window.$zohoLiveChatLoaded) return;
  window.$zohoLiveChatLoaded = true;
  window.$zoho = window.$zoho || {};
  window.$zoho.salesiq = window.$zoho.salesiq || {
    widgetcode: process.env.VUE_APP_ZOHO_WIDGET_CODE || '',
    values: {},
    ready: () => {
      window.$zoho.salesiq.floatbutton.visible("show");
      if (user) {
        window.$zoho.salesiq.visitor.name(user.username);
        window.$zoho.salesiq.visitor.lastname(user.username);
        window.$zoho.salesiq.visitor.email(user.email);
      }
    }
  };
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'zsiqscript';
  script.defer = true;
  script.src = 'https://salesiq.zoho.com/widget';
  document.getElementsByTagName('head')[0].appendChild(script);

  setTimeout(() => {
    const interval = setInterval(() => {
      const widget = document.getElementById('zsiq_float');
      if (widget) {
        clearInterval(interval);
        const margin = 10;
        widget.style.cursor = 'move';
        widget.style.zIndex = '9999';
        widget.style.transition = 'none';
        let isDragging = false;
        let preventClick = false;
        let offsetX = 0;
        let offsetY = 0;
        widget.addEventListener('mousedown', (e) => {
          isDragging = true;
          preventClick = false;
          const rect = widget.getBoundingClientRect();
          offsetX = e.clientX - rect.left;
          offsetY = e.clientY - rect.top;
          widget.style.bottom = 'unset';
          widget.style.right = 'unset';
          widget.style.left = `${rect.left}px`;
          widget.style.top = `${rect.top}px`;
          widget.style.position = 'fixed';
          document.body.style.userSelect = 'none';
        });
        document.addEventListener('mousemove', (e) => {
          if (isDragging) {
            preventClick = true;
            let x = e.clientX - offsetX;
            let y = e.clientY - offsetY;
            const maxX = window.innerWidth - widget.offsetWidth - margin;
            const maxY = window.innerHeight - widget.offsetHeight - margin;
            x = Math.max(margin, Math.min(x, maxX));
            y = Math.max(margin, Math.min(y, maxY));
            widget.style.left = `${x}px`;
            widget.style.top = `${y}px`;
          }
        });
        document.addEventListener('mouseup', () => {
          isDragging = false;
          document.body.style.userSelect = '';
        });
        widget.addEventListener(
          'click',
          (e) => {
            if (preventClick) {
              e.stopImmediatePropagation();
              e.preventDefault();
              preventClick = false;
            }
          },
          true
        );
      }
    }, 300);
  }, 1500);
}

/**
 * Removes the Zoho SalesIQ Live Chat widget from the page.
 */
export function removeZohoChat() {

  if (window.$zoho?.salesiq) {
    window.$zoho?.salesiq?.reset?.();
    window.$zoho?.salesiq?.floatbutton?.visible?.("hide");
    window.$zoho?.salesiq?.floatwindow?.visible?.("hide");
  }

  const script = document.getElementById("zsiqscript");
  if (script) {
    script.remove();
  }

  const widget = document.getElementById("zsiq_float");
  if (widget) {
    widget.remove();
  }

  window.$zoho = undefined;
  window.$zohoLiveChatLoaded = false;
}